import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Forgot Password request is successful.
 * @memberOf Playtech.API.events
 * @event FORGOT_PASSWORD_SUCCESS
 * @type {callback}
 * @example Playtech.on('FORGOT_PASSWORD_SUCCESS', () => { ... });
 */
export const EVENT_FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
/**
 * Event fires when Forgot Password request is failed.
 * @memberOf Playtech.API.events
 * @event FORGOT_PASSWORD_FAIL
 * @type {callback}
 * @example Playtech.on('FORGOT_PASSWORD_FAIL', () => { ... });
 */
export const EVENT_FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';

export const useOnForgotPassword = (eventTarget: EventTarget) => {
    const onForgotPasswordSuccess = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_PASSWORD_SUCCESS, { detail: args }));
    }, [eventTarget]);

    const onForgotPasswordFail = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_PASSWORD_FAIL, { detail: args }));
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('forgotPassword:success', onForgotPasswordSuccess);
        publicEventsAPIService.on('forgotPassword:fail', onForgotPasswordFail);

        return () => {
            publicEventsAPIService.off('forgotPassword:success', onForgotPasswordSuccess);
            publicEventsAPIService.off('forgotPassword:fail', onForgotPasswordFail);
        };
    }, [onForgotPasswordSuccess, onForgotPasswordFail]);
};
